'use client';

import { IconButton } from 'lighthouse';
import { ShareOutlineSmSVG } from 'lighthouse-icons';

import { ShareProductButtonProps } from '@/widgets/ProductDetail/_components/ShareProductButton/models';

import { shareContent } from '@/utilities/shareContent';

export const ShareProductButton = ({ title, description }: ShareProductButtonProps) => {
    const handleShare = () => {
        shareContent({
            title: title,
            text: description,
            url: window.location.href
        });
    };
    return (
        <IconButton className='absolute bottom-[24px] left-[24px] !bg-white shadow-md' onClick={handleShare}>
            <ShareOutlineSmSVG />
        </IconButton>
    );
};
